import { api } from '../client'
import type { RequestOptions } from '../client'
import type { CpvCode } from './types'

export const cpvCodesHttpApi = {
  list: (options?: RequestOptions): Promise<CpvCode[]> => api.get<CpvCode[]>('/cpv-codes', options),
}
